export default __webpack_public_path__ + "static/media/logo.51bb6a23.svg";